export const SITE_NAME = "AquaWorks";
export const SITE_DOMAIN = "aquawork.ca";
export const SITE_URL = (import.meta.env.VITE_SITE_URL || "https://aquawork.ca").replace(/\/$/, "");
export const SITE_TAGLINE = "AquaWorks site located on UBC's Vancouver campus.";
export const SITE_DESCRIPTION =
  "AquaWorks is a student-led engineering project developed by students at the University of British Columbia, building a radar-assisted water-quality monitoring robot.";
export const SITE_ALTERNATE_NAMES = ["AquaWork", "aquawork.ca"] as const;
export const SITE_KEYWORDS =
  "AquaWorks, AquaWork, aquawork.ca, student-led engineering, water quality monitoring, Vancouver campus";
export const CONTACT_EMAIL = "jhan31@student.ubc.ca";
export const OG_IMAGE_PATH = "/logo.png";
export const LOGO_PATH = "/logo.png";
